// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice'; // User authentication reducer
import authReducer from './admin/auth/authSlice';
import profileReducer from './admin/profile/profile-slice';
import adminReducer from './admin/admin_user/adminSlice';
import categoryReducer from './admin/category/category_slices';
import ProductReducer from './admin/product/product_slices';
import UserAuthReducer from './user/user_auth/user_authSlice';
import UserProfileReducer from './user/user_profile/user_profile-slice';
import UserProductReducer from './user/product/user_product_slices';
import shopReducer from './user/shop/shopSlice';
import cartReducer from './user/cart/cartSlices';
import landpageReducer from './user/landingpageproducts/landingpage_slice';
import RoomReducer from './user/room/roomSlice';
import AdminRoomReducer from './admin/admin_room/roomSlice';
import UserOrderReducer from './user/user_order/user_order_slices';
import AdminOrderReducer from './admin/admin_order/admin_order_slices';
import BloggerReducer from './admin/bloggers/bloggersSlices';
import WishListReducer from './user/wish_list/wish_list_slices';
import UserBlogReducer from './user/blog/blogSlice';
import CustomerReducer from './admin/customer/customer_slice';
import BrandReducer from './admin/brand/brand_slices';
import MacueReducer from './admin/macue/macue_slices';
import ReviewReducer from './admin/review/review_slices';
import MajorCategoryReducer from './admin/major_category/major_category_slices';
import ReelsReducer from './admin/reels/reels_slices';
import brandsReducer from './user/brands/brands_slices';
import majorCategoriesReducer from './user/majorcategories/majorCategories_slices';
import testimonialsReducer  from './user/review/reviewsSlices';


const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    profile: profileReducer,
    admin: adminReducer,
    category: categoryReducer,
    product: ProductReducer,
    user_auth: UserAuthReducer,
    user_profile: UserProfileReducer,
    user_product: UserProductReducer,
    shop: shopReducer,
    user_cart: cartReducer,
    landpage: landpageReducer,
    room: RoomReducer,
    admin_room: AdminRoomReducer,
    user_order: UserOrderReducer,
    admin_order: AdminOrderReducer,
    blogger: BloggerReducer,
    user_wish_list: WishListReducer,
    user_blog: UserBlogReducer,
    customers: CustomerReducer,
    brand: BrandReducer,
    macue: MacueReducer,
    review: ReviewReducer,
    major_category: MajorCategoryReducer,
    reels: ReelsReducer,
    brands: brandsReducer,
    majorCategories: majorCategoriesReducer,
    testimonials: testimonialsReducer,
  },
});

export default store;
